/**
 * Пауза перед ударами ближнего боя, если на поле только что погибли отряды от стрельбы:
 * гибель и бой приходят одним пакетом, и без паузы первые удары идут поверх нее.
 *
 * Отдельный маленький источник, а не redux — как у ударов (см. meleeAnimationTracker):
 * это состояние анимации, а не партии.
 */
let pauseUntil = 0;

/** На поле пошла гибель отрядов: удары начнутся не раньше чем через pauseMs */
export const startUnitDeathPause = (pauseMs) => {
  pauseUntil = Date.now() + pauseMs;
};

/** Сколько ударам еще ждать, мс */
export const getUnitDeathPauseMs = () => Math.max(0, pauseUntil - Date.now());
